'use strict';

/**
 * @classname Slider
 * @classdesc スライダー
 */
export default class Slider {
	/**
	 * @constructor
	 * @param {jQuery} $e - .banner-slide
	 */
	constructor($e) {
		console.log(`${this.constructor.name}.constructor`);
		let options = {
			loop: true,
			slidesPerView: 'auto',
			spaceBetween: 30,
			speed: 5000,
			allowTouchMove: false,
			autoplay: {
				delay: 0,
				disableOnInteraction: false,
			},
			breakpoints: {
				992: {
					spaceBetween: 50,
				}
			}
		}
		console.log(options);
		const swiper = new Swiper('.banner-slide', options);
	};
};
